import React from "react";
import * as styles from "./base.scss";
import { getInitialsForProfile, isSubCustomer, } from "../../../RightMenu/Profile/index";
import connect from "Shared/connect";
import Icon from "Shared/Icon";
import { toggleRightMenu } from "../../../RightMenu/action-creators";
import ToolTip from "Shared/ProductTooltip/ToolTip";
const ProfileDropdown = (props) => {
    const IsSubCustomer = isSubCustomer(props.currentUser);
    const Initials = IsSubCustomer
        ? getInitialsForProfile(props.currentUser.companyName)
        : getInitialsForProfile(props.currentUser.fullName);
    const toggleRightMenu = () => {
        props.toggleRightMenu();
    };
    return (React.createElement("div", { className: styles.dropdownContainer },
        !!props.rightMenuIsOpen ? (React.createElement("button", { className: styles.dropdownButton, onClick: toggleRightMenu },
            Initials,
            React.createElement(Icon, { name: props.rightMenuIsOpen
                    ? "header-profile-up-arrow"
                    : "header-profile-down-arrow" }))) : (React.createElement(ToolTip, { className: styles.tooltip, text: props.currentUser.fullName + " (" + props.currentUser.customerId + ")", direction: "custom", disableAdjust: true },
            React.createElement("button", { className: styles.dropdownButton, onClick: toggleRightMenu },
                Initials,
                React.createElement(Icon, { name: props.rightMenuIsOpen
                        ? "header-profile-up-arrow"
                        : "header-profile-down-arrow" })))),
        " "));
};
export default connect((state) => ({
    currentUser: state.currentUser,
    activeExhibition: state.currentUser.activeExhibition,
    rightMenuIsOpen: state.mainMenu.rightMenuIsOpen,
    initials: state.mainMenu.initails,
}), (dispatch) => ({
    toggleRightMenu: () => dispatch(toggleRightMenu()),
}))(ProfileDropdown);
